import React, { Component } from 'react';
import './RegistrationSuccess.css';
import { Link } from 'react-router-dom'
import Alert from 'react-s-alert';

class RegistrationSuccess extends Component {
    componentDidMount() {
        // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
        // Here we display the error and then remove the error query parameter from the location.
        if(this.props.location.state && this.props.location.state.error) {
            setTimeout(() => {
                Alert.error(this.props.location.state.error, {
                    timeout: 5000
                });
                this.props.history.replace({
                    pathname: this.props.location.pathname,
                    state: {}
                });
            }, 100);
        }
    }
    
    render() {
        // if(this.props.authenticated) {
        //     return <Redirect
        //         to={{
        //         pathname: "/",
        //         state: { from: this.props.location }
        //     }}/>;
        // }

        return (
            <div className="container text-center">
                <h3>You have signed up successfully!</h3>
                <p>Please check your email to verify your account.</p>
                <h4><Link to="/login">Click here to Login</Link></h4>
            </div>
        );
    }
}

export default RegistrationSuccess



// WEBPACK FOOTER //
// ./src/user/registration_success/RegistrationSuccess.js